import { IBooking, ICustomer, IVenue } from 'shared-types/index';
export const classPrefix = 'PaymentLinkInfo';
export interface IPaymentLinkInfo extends IProps, IHandlers, IServices {}

/**
 * Properties passed in from angular instantiation.
 * This can include functions/handlers that simply call back to the Angular parent component
 * and do not need to modify app state (via a service).
 */
export interface IContainerProps extends IBaseProps {
  booking: IBooking;
  closeOnSuccess: boolean;
  handleSendLinkPaymentResponse: (errName: string) => void;
  handleWaitForSave?: () => Promise<{success: boolean, reason?: string}>;
  isUnitTest?: boolean;
  isShorterContainerInEditBooking?: boolean;
}

export interface IBaseProps {
  paymentUrl: string;
  hideDetails: boolean;
  showImage: boolean;
  saveEmailToCustomer: boolean;
  savePhoneNumberToCustomer: boolean;
  handleSave?: () => void;
}

/**
 * Properties passed directly into the react component. If the container is responsible for fetching async data, via a
 * service, these may differ from IContainerProps.
 */
export interface IProps extends IBaseProps {
  isEmailValid: boolean;
  isPhoneValid: boolean;
  validEmailMessage: string;
  validPhoneMessage: string;
  email: string;
  mobilePhone:string;
  isStandbyBookingType: boolean;
  isStandbyPending: boolean;
  isBookingExpired: boolean;
  smsEnabled:boolean;
  venueCountry?: string;
  disableEmailSmsNotification?: boolean;

  customer?: ICustomer;

  enableBookedByOnDiary?: boolean;
  booking?: IBooking;
  isBookedByEmailValid?: boolean;
  validBookedByEmailMessage?: string;
  isBookedByPhoneValid?: boolean;
  bookedByMobilePhone?: string;
  validBookedByPhoneMessage?: string;
  bookedByEmail?: string;
  saveBookedByPhoneNumberToBooking?: boolean;
  saveBookedByEmailToBooking?: boolean;
  isShorterContainerInEditBooking?: boolean;
}

/**
 * Handlers used to modify app state (via a service) from within the module's container.
 * Similar to redux mapDispatchToProps.
 */
export interface IHandlers {
  handleEmailChanged: (value: string) => void;
  handleMobilePhoneChanged: (value: string) => void;
  handleSaveEmailToCustomerChanged: (value: boolean) => void;
  handleSavePhoneNumberToCustomerChanged: (value: boolean) => void;
  handleSendLinkPayment: (isBookedBy: boolean) => Promise<boolean>;
  handleSendSmsLinkPayment: (isBookedBy: boolean) => Promise<boolean>;
  handleOpenStandbyPayments: () => Promise<{success: boolean, reason?: string}>;
  handleSaveButtonClick: () => void;
  handleCloseButtonClick:() => void;
  handleBookedByEmailChanged?: (value: string) => void;
  handleBookedByMobilePhoneChanged?: (value: string) => void;
  handleSaveBookedByEmailToCustomerChanged?: (value: boolean) => void;
  handleSaveBookedByPhoneNumberToCustomerChanged?: (value: boolean) => void;
}

export interface IServices {

}
